<script setup lang="ts">
import { VERSION } from '@cinqo/common'
import { RotateCcwIcon } from 'lucide-vue-next'
import { hotReload } from '~/helpers/UtilsHelper'

async function hotReloadApp() {
  await hotReload()
}
</script>

<template>
  <div class="h-full w-full flex">
    <!-- Navbar skeleton -->
    <div class="h-full w-60 bg-base-200 p-4 flex flex-col gap-4">
      <div class="skeleton h-10 w-40 mb-8" />
      <div class="skeleton h-6 w-40 mb-2" />
      <div class="skeleton h-6 w-48 mb-2" />
      <div class="skeleton h-6 w-36 mb-2" />
      <div class="skeleton h-6 w-44 mb-2" />
      <div class="skeleton h-6 w-40 mb-8" />

      <div class="skeleton h-6 w-40 mb-2" />
      <div class="skeleton h-6 w-48 mb-2" />
      <div class="mt-auto flex items-center gap-2">
        <RotateCcwIcon
          :size="24"
          class="text-base-content cursor-pointer"
          @click="hotReloadApp"
        />
        <span class="text-sm">{{ VERSION }}</span>
      </div>
    </div>

    <!-- Main content skeleton -->
    <div class="flex-1 p-6 flex flex-col gap-4">
      <!-- Title skeleton -->
      <div class="skeleton h-12 w-96 mb-6" />

      <!-- Subtitle skeleton -->
      <div class="skeleton h-8 w-80 mb-4" />

      <!-- Content blocks -->
      <div class="skeleton h-40 w-full mb-4" />
      <div class="flex gap-4 mb-4">
        <div class="skeleton h-32 w-1/3" />
        <div class="skeleton h-32 w-1/3" />
        <div class="skeleton h-32 w-1/3" />
      </div>
      <div class="skeleton h-56 w-full" />
    </div>
  </div>
</template>
